import "./App.scss";

import React from "react";
import { About, Footer, Header, Skills, Testimonial, Work, Education } from "./container";
import { Navbar } from "./components";

const App = () => { 
  return (
    <div className="app">
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonial />
      <Education/>
      <Footer />
    </div>
  );
};

export default App;
